import type { WorkflowActionableType } from '@/api/entity_types/workflow/WorkflowDefinition';

export type ActionTypeStyle = {
  icon: string;
  bg: string;
  text: string;
  label: string;
};

const ACTION_TYPE_STYLES: Record<WorkflowActionableType, ActionTypeStyle> = {
  WorkflowActionEmail: { icon: 'mail', bg: 'bg-blue-50', text: 'text-blue-600', label: 'Email' },
  WorkflowActionSms: { icon: 'message-circle', bg: 'bg-emerald-50', text: 'text-emerald-600', label: 'SMS' },
  WorkflowActionOneOffTask: { icon: 'check-square', bg: 'bg-amber-50', text: 'text-amber-600', label: 'Task' },
};

const FALLBACK_ACTION_TYPE_STYLE: ActionTypeStyle = {
  icon: 'zap',
  bg: 'bg-gray-50',
  text: 'text-gray-600',
  label: 'Action',
};

export const actionTypeStyle = (type: WorkflowActionableType): ActionTypeStyle =>
  ACTION_TYPE_STYLES[type] ?? FALLBACK_ACTION_TYPE_STYLE;
